import { Navigate } from 'react-router-dom';
import { getDefaultRoute } from '../../hooks/usePermission';
import { hasUsableSession } from '../../utils/authHelpers';
import AlreadyLoggedIn from './AlreadyLoggedIn';

/**
 * 비로그인 사용자만 접근 가능한 라우트 (로그인/회원가입 등)
 * 이미 로그인된 사용자는 서비스 타입에 맞는 기본 페이지로 리다이렉트
 */
function GuestOnlyRoute({ children, showCurrentCompany = false }) {
  /* 토큰만 보면 안 된다 — 반쪽 상태(토큰은 있고 serviceType 이 없음)일 때
     ProtectedRoute 와 서로 밀어내며 무한 리다이렉트가 났다(2026-08-01). */
  if (hasUsableSession()) {
    /* 첫 화면(회사 코드 입력)은 말없이 넘기지 않고 지금 회사를 보여 준다(2026-10-06 fwee·numbuzin 문의) */
    if (showCurrentCompany) return <AlreadyLoggedIn />;
    return <Navigate to={getDefaultRoute()} replace />;
  }

  return children;
}

export default GuestOnlyRoute;
